import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App'
import { store } from './app/store'
import { Provider } from 'react-redux'
// font

import "./fonts/timesnewroman.ttf"
import "./fonts/timesnewromanbold.ttf"
import "./fonts/timesnewromanboldtalic.ttf"
import "./fonts/timesnewromanitalic.ttf"


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>
);

